/**
 * Lender condition tracking outline (not a file-readiness checklist).
 * Uses the same applicability rules as file-checklist/conditions.ts conceptually,
 * but tracks outstanding lender conditions post-submission.
 */
export const LENDER_CONDITION_TRACKING_SECTIONS = [
  {
    id: "income",
    title: "Income & employment",
    examples: [
      "Updated paystub within 30 days",
      "Letter of employment on lender letterhead",
      "NOA or T1 if self-employed",
    ],
  },
  {
    id: "down_payment",
    title: "Down payment & assets",
    examples: [
      "90-day bank statements",
      "Gift letter + donor proof of funds",
      "Sale of previous property — firm sale agreement",
    ],
  },
  {
    id: "property",
    title: "Property & appraisal",
    examples: [
      "Signed purchase contract",
      "Appraisal ordered / received",
      "Condo docs or status certificate",
    ],
  },
  {
    id: "identity_aml",
    title: "Identity & AML",
    examples: ["Government ID", "Proof of address", "Source-of-funds narrative"],
  },
  {
    id: "insurance_title",
    title: "Insurance & title",
    examples: [
      "Home insurance binder",
      "Fire insurance if required",
      "Title / lawyer instructions",
    ],
  },
  {
    id: "lender_specific",
    title: "Lender-specific conditions",
    examples: [
      "Signed commitment",
      "Rate hold confirmation",
      "Outstanding solicitor requirements",
    ],
  },
] as const;

export const LENDER_CONDITION_TRACKING_DISCLAIMER =
  "This condition checklist is a working tracker for the broker team. It is not a lender approval or compliance sign-off.";

export function formatLenderConditionTrackingOutline(): string {
  const lines = [
    LENDER_CONDITION_TRACKING_DISCLAIMER,
    "",
    "## Condition tracking sections",
  ];
  for (const section of LENDER_CONDITION_TRACKING_SECTIONS) {
    lines.push(`### ${section.title}`);
    for (const ex of section.examples) {
      lines.push(`- ${ex}`);
    }
    lines.push("");
  }
  return lines.join("\n").trim();
}
